import script from "./search-examples.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-examples.vue?vue&type=script&setup=true&lang=ts"

import "./search-examples.vue?vue&type=style&index=0&id=b138467c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b138467c"]])

export default __exports__